module.exports = __webpack_public_path__ + "static/linkoping-university-8f070249b463dbc3bd8b3bd9cf0d10f5.png";